export interface CreditTopUpRequest {
  /** Credits the refused action was missing, when known. */
  shortfall?: number
}

type Listener = (request: CreditTopUpRequest) => void

const listeners = new Set<Listener>()

/** Asks the dashboard to offer more credits, e.g. after a paid action was refused for lack of them. */
export function requestCreditTopUp(request: CreditTopUpRequest = {}): void {
  for (const listener of listeners) listener(request)
}

export function onCreditTopUpRequest(listener: Listener): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}
